import Api, { ApiConfig } from '@/api/base/api'
import { CancelTokenSource } from 'axios'
import { Seller } from '@/types/seller'

class SellerApi extends Api {
  public cancelToken: CancelTokenSource | null = null

  constructor(configs?: ApiConfig & { headers?: { [key: string]: string | number | object | null | undefined | void } }) {
    super({
      baseURL: `${process.env.VUE_APP_SERVER_ENDPOINT_SELLER}`,
      ...configs,
    })
  }

  /**
   * [사업자등록번호 검증]
   * @param registerNo 사업자등록번호
   */
  getBusinessValidate(registerNo: number) {
    return this.requestGet<Common.TApiResponseWrapper<Seller.ValidatedCheck>>(`/seller/business/validate/${registerNo}`)
  }

  /**
   * [아이디 검증]
   * @param accountId 상호명
   */
  getAccountsValidate(accountId: string) {
    return this.requestGet<Common.TApiResponseWrapper<Seller.DuplicatedCheck>>(`/accounts/${accountId}`)
  }

  /**
   * [상호명 검증]
   * @param sellerName 상호명
   * @param isEnName 영문명 여부
   */
  getNameValidate(sellerName: string, isEnName = false) {
    return this.requestGet<Common.TApiResponseWrapper<Seller.DuplicatedCheck>>(`/seller/name/${sellerName}`, { 'en-name': isEnName })
  }

  /**
   * [셀러 회원가입]
   * @param formData 회원가입 폼데이터
   */
  postSellerSignUp(formData: Seller.MdSignUp) {
    return this.requestPost<Common.TApiResponseWrapper>('/seller/signup', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
  }

  /*
   * 셀러 정보 조회
   * @param sellerNo 셀러 번호
   */
  getSellerInfo(sellerNo: number) {
    return this.requestGet<Common.TApiResponseWrapper>(`/seller/${sellerNo}`)
  }

  /**
   * MDM 토큰 재갱신
   */
  postAuthMdmToken() {
    return this.requestPost<Common.TApiResponseWrapper>(
      '/auth/mdm/refresh',
      {},
      {
        headers: {
          Authorization: this.token,
          // 'service-no': this.store.getters.serviceNo,
          // 'solution-no': this.store.getters.serviceNo,
          // 'b-referer': location.href,
        },
      }
    )
  }

  /**
   * 비즈센터
   */
  getSellerBizcenterRedirect() {
    return this.requestGet<Common.TApiResponseWrapper>(`/seller/bizcenter/redirect`)
  }

  /**
   * 셀러 추가정보 입력여부 검증 (셀러 회원가입 완료 여부)
   */
  getSellerValidate(sellerNo: string) {
    return this.requestGet<Common.TApiResponseWrapper<Seller.ValidatedCheck>>(`/seller/${sellerNo}/validate`)
  }
}

export default SellerApi
